export default class User
{
    constructor(id, name, description, email, username, active, roles, roleNames, permissions, permissionNames, created_at, updated_at){
        this.id                 = id ?? 0
        this.name               = name
        this.description        = description
        this.email              = email
        this.username           = username
        this.active             = active
        this.roles              = roles
        this.roleNames          = roleNames
        this.permissions        = permissions
        this.permissionNames    = permissionNames
        this.created_at         = created_at
        this.updated_at         = updated_at
    }

    hasPermission(perName = null){
        return this.permissionNames.includes(perName)
    }

    hasAnyPermission(perNames){
        let target = false
        for (let i = 0; i < perNames.length; i++){
            target = this.permissionNames.includes(perNames[i])
            if(target) return target
        }
        return target
    }

    hasAllPermissions(perNames){
        let target = false
        for (let i = 0; i < perNames.length; i++){
            target = this.permissionNames.includes(perNames[i])
            if(!target) return target
        }
        return target
    }

    hasRole(rlName = null){
        return this.roleNames.includes(rlName)
    }

    hasAnyRole(rlNames){
        let target = false
        for (let i = 0; i < rlNames.length; i++){
            target = this.roleNames.includes(rlNames[i])
            if(target) return target
        }
        return target
    }

    hasAllRoles(rlNames){
        let target = false
        for (let i = 0; i < rlNames.length; i++){
            target = this.roleNames.includes(rlNames[i])
            if(!target) return target
        }
        return target
    }
}